@if ((customerState$ | async); as customerStateData) {
  @if (customerStateData.isViewer || customerStateData.isGuest) {
    <h3>{{ 'orders-page.page-title-buyer' | translate }}</h3>
  }
}
<app-access-control [notForViewer]="true" [description]="true">
  <ng-container ngProjectAs="[slot][nonViewerContent]">
    <div class="my-orders__container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          @if (companyRoles && !checkRolesForAccess()) {
            <h3>{{ 'orders-page.page-title-buyer' | translate }}</h3>
          } @else {
            <h3>{{ 'orders-page.page-title' | translate }}</h3>
          }
        </div>
      </div>
      <!--Tabbed navigation-->
      @if (isAnyOrderTab && !showInitialLoader()) {
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10">
            <div class="bare-list tabs__list">
              <!--  originalOrderOfTabs: avoid of sorting tabs    -->
              @for (tab of hospitalOrdersTabsMap | keyvalue: originalOrderOfTabs; track tab) {
                @if (tab.value) {
                  <h6
                    class="tabs__item"
                    [attr.data-test]="'tab-' + tab.key"
                    [ngClass]="{'is-active is-active__bar': currentTab === tab.key}"
                    (click)="changeTab(tab.key)">
                    {{ 'orders-page.' + tab.key | translate }}
                  </h6>
                }
              }
            </div>
          </div>
        </div>
      }
      @if (showInitialLoader()) {
        <div>
          <div class="loader__content">
            <div class="loading-animation"></div>
          </div>
        </div>
      }
      <!--   If there is no previous orders or carts   -->
      @if (!showInitialLoader() && !isAnyOrderTab) {
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10">
            <div class="col-12">
              <p>{{ 'orders-page.no-history-orders-message' | translate }}</p>
              <br/>
            </div>
          </div>
        </div>
      }
      <!--  Pending orders tab    -->
      @if (!showInitialLoader()
        && pendingOrders.length > 0
        && currentTab === HospitalOrderTabs.PENDING_ORDERS) {
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10">
            @if (companyRoles && checkRolesForAccess()) {
              <span class="section__title">
                {{ 'orders-page.approver-pending-orders' | translate }}
              </span>
            }
            @if (companyRoles && !checkRolesForAccess()) {
              <span class="section__title">
                {{ 'orders-page.pending-orders' | translate }}
              </span>
            }
          </div>
        </div>
        <div class="row justify-content-center pending-orders" [attr.data-test]="'desc-pendingOrders'">
          <app-access-control [description]="true">
            <ng-container ngProjectAs="[slot][content]">
              @if (pendingOrders.length > 0) {
                <div class="col-12 col-lg-10">
                  <app-pending-orders-list
                    [orders]="pendingOrders"
                    [loading]="pendingOrdersLoading"
                    [tabsOpened]="openedTabsForPendingOrders"
                    [roleAccess]="checkRolesForAccess()"
                    (refreshOrdersEmitter)="reloadDataAfterDeletingItemFromPendingOrder()"
                    (openTabIdEmitter)="retrievePendingOrderOpenedTabId($event)">
                  </app-pending-orders-list>
                </div>
              }
            </ng-container>
          </app-access-control>
        </div>
      }
      <!--   Previous orders tab   -->
      @if (!showInitialLoader()
        && (ordersHistoryList.length > 0 || onlyMineOrders)
        && currentTab === HospitalOrderTabs.PREVIOUS_ORDERS) {
        <div class="row justify-content-center">
          <div class="previous-orders__section col-12 col-lg-10">
            @if (companyRoles && checkRolesForAccess()) {
              <span class="section__title">
                {{ 'orders-page.approver-previous-orders' | translate }}
              </span>
            }
            @if (companyRoles && !checkRolesForAccess()) {
              <span class="section__title">
                {{ 'orders-page.previous-orders' | translate }}
              </span>
            }
            @if (!isGuest &&
              (ordersHistoryList.length > 0 || onlyMineOrders)) {
              @if (companyRoles && checkRolesForAccess()) {
                <div
                  class="section__title--only-mine"
                  [ngClass]="{'filtering': filteringHistoryInProgress}">
                  <input
                    id="show-mine-checkbox"
                    type="checkbox"
                    name="show-mine-checkbox"
                    class="checkbox"
                    [disabled]="orderHistoryListLoading"
                    [checked]="onlyMineOrders"
                    (change)="selectOnlyUserOrders();"/>
                  <label for="show-mine-checkbox">{{ 'orders-page.only-my-orders-checkbox' | translate }}</label>
                </div>
              }
              <div class="js-search-field search-field textfield textfield--with-prefix">
                <span class="textfield__prefix icon-search"></span>
                <input
                  id="search"
                  name="search"
                  type="search"
                  class="textfield__input search-field__input"
                  spellcheck="false"
                  autocomplete="off"
                  placeholder="{{ 'orders-page.search' | translate }}"
                  [disabled]="orderHistoryListLoading"
                  [(ngModel)]="searchPreviousOrder"/>
                <label for="search" style="display: none"></label>
              </div>
            }
          </div>
        </div>
        <div class="row justify-content-center previous-orders" [attr.data-test]="'desc-previousOrders'">
          <app-access-control [description]="true">
            <ng-container ngProjectAs="[slot][content]">
              @if (ordersHistoryList.length > 0) {
                <div class="col-12 col-lg-10">
                  @if (!orderHistoryListAtPageLoading) {
                    <app-previous-orders-list
                      [loading]="orderHistoryListLoading"
                      [orders]="ordersHistoryList"
                      [roleAccess]="checkRolesForAccess()"
                      [searchValue]="searchPreviousOrder">
                    </app-previous-orders-list>
                  } @else {
                    <div class="loader__content">
                      <div class="loading-animation"></div>
                    </div>
                  }
                  <app-pagination-linkless
                    [pageCount]="ordersNumPages"
                    [currentPage]="ordersCurrentPage"
                    (pageChange)="goToOrdersHistoryPage($event)">
                  </app-pagination-linkless>
                </div>
              }
            </ng-container>
          </app-access-control>
        </div>
      }

      <!--   Previous quotes tab   -->
      @if (
        !showInitialLoader()
        && previousQuotes.length > 0
        && currentTab === HospitalOrderTabs.PREVIOUS_QUOTES) {
        <div class="row justify-content-center">
          <div class="previous-orders__section col-12 col-lg-10">
            <span class="section__title">
              {{ 'orders-page.previous-quotes' | translate }}
            </span>
            @if (!isGuest && previousQuotes.length > 0) {
              <div class="js-search-field search-field textfield textfield--with-prefix">
                <span class="textfield__prefix icon-search"></span>
                <input
                  id="search-quote"
                  name="searchQuotes"
                  type="search"
                  class="textfield__input search-field__input"
                  spellcheck="false"
                  autocomplete="off"
                  placeholder="{{ 'orders-page.search-quotes' | translate }}"
                  [disabled]="previousRequestsLoading"
                  [(ngModel)]="searchPreviousQuotes"/>
                <label for="search-quote" style="display: none"></label>
              </div>
            }
          </div>
        </div>
        <div class="row justify-content-center previous-orders" [attr.data-test]="'desc-previousQuotes'">
          <app-access-control [description]="true">
            <ng-container ngProjectAs="[slot][content]">
              @if (previousQuotes.length > 0) {
                <div class="col-12 col-lg-10">
                  <app-previous-quotes-list
                    [orders]="previousQuotes"
                    [loading]="previousRequestsLoading"
                    [searchValue]="searchPreviousQuotes"
                    [roleAccess]="checkRolesForAccess()">
                  </app-previous-quotes-list>
                </div>
              }
            </ng-container>
          </app-access-control>
        </div>
      }
      <!--   Previous requests tab   -->
      @if (!showInitialLoader()
        && previousRequests.length > 0
        && currentTab === HospitalOrderTabs.PREVIOUS_REQUESTS) {
        <div class="row justify-content-center">
          <div class="previous-orders__section col-12 col-lg-10">
            <span class="section__title">
              {{ 'orders-page.previous-request' | translate }}
            </span>
            @if (!isGuest && previousRequests.length > 0) {
              <div class="js-search-field search-field textfield textfield--with-prefix">
                <span class="textfield__prefix icon-search"></span>
                <input
                  id="search-request"
                  name="searchRequest"
                  type="search"
                  class="textfield__input search-field__input"
                  spellcheck="false"
                  autocomplete="off"
                  placeholder="{{ 'orders-page.search-request' | translate }}"
                  [disabled]="previousRequestsLoading"
                  [(ngModel)]="searchPreviousRequest"/>
                <label for="search-request" style="display: none"></label>
              </div>
            }
          </div>
        </div>
        <div class="row justify-content-center previous-orders" [attr.data-test]="'desc-previousRequests'">
          <app-access-control [description]="true">
            <ng-container ngProjectAs="[slot][content]">
              @if (previousRequests.length > 0) {
                <div class="col-12 col-lg-10">
                  <app-previous-requests-list
                    [orders]="previousRequests"
                    [loading]="previousRequestsLoading"
                    [searchValue]="searchPreviousRequest"
                    [roleAccess]="checkRolesForAccess()">
                  </app-previous-requests-list>
                </div>
              }
            </ng-container>
          </app-access-control>
        </div>
      }
      @if (showOrdersOrRequests()) {
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10">
            <p>{{ 'orders-page.no-history' | translate }}</p>
          </div>
        </div>
      }
    </div>
  </ng-container>
</app-access-control>
